import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ConversaProvider } from '../../providers/conversa/conversa';
import { ViewProvider } from '../../providers/view/view';

/**
 * Generated class for the ConversaNutriPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-conversa-nutri',
  templateUrl: 'conversa-nutri.html',
})
export class ConversaNutriPage {

  nutricionista = {nome:''};

  mensagens:Array<any> =[
  ]

  textoMensagem = "";


  conversa:any = {};
  
  interval:any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private view:ViewProvider, private conversaProvider:ConversaProvider) {

  }

  ionViewDidLoad() {

    this.interval = setInterval(
      () => {
        this.carregarMensagens();
      }, 5000
    );

    if(this.navParams.get('conversa')){
      this.conversa = this.navParams.get('conversa');

      this.carregarMensagens();
    }
  }


  ionViewWillLeave(){
    if(this.interval){
      clearInterval(this.interval);
    }
  }
  encerrarConversa(){
    this.view.showConfirm("Deseja encerrar a conversa?", () =>{
      this.conversaProvider.encerrarConversa(this.conversa.id).subscribe(
        (dados) => {

          this.navCtrl.pop();
        },
        (err) => console.error(err)
      )
    });
  }

  enviarMensagem(){
    if(!this.textoMensagem){
      return;
    }

    if(this.conversa && this.conversa.id){
      this.conversaProvider.enviarMensagem(this.conversa.id, this.textoMensagem).subscribe(
        (mensagens) => {
          this.mensagens = mensagens;
          this.textoMensagem = "";
        },
        (err) => console.error(err)
      )
      return;
    }

    this.conversaProvider.iniciarConversa(this.textoMensagem).subscribe(
      (conversa_id) => {
        this.conversa = {id : conversa_id};
        this.textoMensagem = "";
      },
      (err) => console.error(err)
    );
  }

  carregarMensagens(){
    if(!this.conversa || !this.conversa.id){
      return;
    }

    this.conversaProvider.carregarMensagens(this.conversa.id).subscribe(
      (mensagens) => {
        this.mensagens = mensagens
      },
      (err) => console.error(err)
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-nutri/conversa-nutri.ts